import { createRoute } from '@/utils/routing'

export const PRIVATE_CASHBACK_SETUP_ROUTE = 'cashback-setup-index-private'
export const LEGAL_CASHBACK_SETUP_ROUTE = 'cashback-setup-index-legal'

export function createPrivateCashbackSetupRoute (options = {}) {
  return createRoute(PRIVATE_CASHBACK_SETUP_ROUTE, options)
}

export function createLegalCashbackSetupRoute (options = {}) {
  return createRoute(LEGAL_CASHBACK_SETUP_ROUTE, options)
}
